module.exports = __webpack_public_path__ + "img/Hotmart-11-es.8c002fc0.png";